module.exports = __webpack_public_path__ + "fonts/Rubik-Bold.071fcca9.ttf";